import Vue from "vue"
import Vuex from "vuex"
import appleGiftCard from "./apple-gift-card"

Vue.use(Vuex)

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootState {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootGetterInstance {}

export default new Vuex.Store<RootState>({
  modules: {
    appleGiftCard
  }
})
